// extracted by mini-css-extract-plugin
export default {"root":"StatsCard_root__rklq0"};